import React, { useState, useEffect } from "react";
import "../Style.css";
import "../Responsive.css";
import "../bootstrap.min.css";
import { loadProductsFromServer } from "../core/serviceClient";
import { Box, Container, Stack } from "@mui/system";
import Utils from "../core/Utils";
import UserHelper from "../core/UserHelper";
import {
    BelowThresholdPage,
    LoginPage,
    PurchaseOrderPage,
} from "../core/PageConstants";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Typography,
} from "@mui/material";
import Loader from "./common/Loader";
import MessagePopup from "./common/MessagePopUp";
import SideBarMenuItems from "./SideBarMenuItems";
import { SideBarMenuNames } from "../core/Constants";
import { OverviewPage } from "../core/PageConstants";
import "../DateRangePickerWithYear.css";
import "react-calendar/dist/Calendar.css";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useDispatch } from "react-redux";
import { getCountry } from "../data/localSettingsActions";
import { Label } from "@mui/icons-material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { connectToStore } from "../data/store";
import { postAsync } from "../core/serviceClient";
import VendorSelectionDialog from "./dialogs/VendorSelectionDialog";
import noResult from "../images/noResult.png";

const BelowThreshold = () => {
    document.title = "Below Threshold";
    var pageTitle = "Below Threshold";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [msgOpen, setMsgOpen] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
    const [isSelectedProduct, setIsSelectedProduct] = useState(false);
    const [vendorList, setVendorList] = useState([]);
    const [localSettings, setLocalSettings] = useState({});
    const [selectedVendor, setSelectedVendor] = React.useState("");

    useEffect(() => {
        let localSetting = connectToStore();
        if (UserHelper.CheckPermission(BelowThresholdPage, navigate)) {
            setLocalSettings(localSetting);
            getBelowThresholdProducts();
        }
    }, []);

    const getBelowThresholdProducts = async () => {
        setIsLoading(true);
        var result = await loadProductsFromServer();
        setIsNavigateToLogin(result.isNavigateToLogin);
        if (result.error) {
            setMsgOpen(true);
            setMsgText(result.errorMessage);
        }
        var data = result.data;
        if (!Utils.IsNullOrEmptyArray(data)) {
            data = data.filter(
                (c) =>
                    c.service === false &&
                    c.isMaterial === false &&
                    c.threshold > c.onHandQuantity
            );
        }
        setProducts(data);
        setIsLoading(false);
    };
    const handleMsgClose = () => {
        setMsgOpen(false);
        if (isNavigateToLogin) {
            UserHelper.LogOut(dispatch);
            navigate(LoginPage.Path);
        }
    };
    const backNavigation = () => {
        navigate(OverviewPage.Path, {});
    };

    const handleCheckboxChange = (index, checked) => {
        let updatedProducts = [...products];
        updatedProducts[index].isChecked = checked;

        setProducts(updatedProducts);
        let selectedItems = updatedProducts.filter((p) => p.isChecked);
        setSelectedProducts(selectedItems);
    };

    const handleCartClick = () => {
        setIsSelectedProduct(!isSelectedProduct);
    };
    const [openDialog, setOpenDialog] = React.useState(false);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    useEffect(() => {
        getVendorDetails();
    }, [localSettings]);

    const getVendorDetails = async () => {
        if (localSettings.authenticated) {
            setIsLoading(true);
            let result = await postAsync(
                "Vendor/GetVendorDetails",
                {},
                "",
                "GetAll",
                "GetAllVendorDetailsByBusiness",
                [localSettings.business.id]
            );
            setIsNavigateToLogin(result.isNavigateToLogin);
            if (result.error) {
                setMsgOpen(true);
                setMsgText(result.errorMessage);
            } else {
                if (!Utils.IsNullOrEmptyArray(result.data)) {
                    setVendorList(
                        (result?.data || []).filter((v) => v.vendorStatus === true)
                    );
                }
            }
            setIsLoading(false);
        }
    };
    const isAnyProductSelected = products.some((product) => product.isChecked);
    const NavigationPurchaseOrder = () => {
        navigate(PurchaseOrderPage.Path, {
            state: {
                SelectedProduct: selectedProducts,
                SelectedVendor: selectedVendor,
            },
        });
        setSelectedProducts([]);
    };
    return (
        <Container maxWidth="false" className="bg-color p-0">
            <Grid className="container">
                <Loader open={isLoading} />
                <MessagePopup
                    msgOpen={msgOpen}
                    msgText={msgText}
                    onMsgClose={handleMsgClose}
                />
                <VendorSelectionDialog
                    open={openDialog}
                    onClose={handleCloseDialog}
                    vendorList={vendorList}
                    selectedVendor={selectedVendor}
                    setSelectedVendor={setSelectedVendor}
                    onSubmit={NavigationPurchaseOrder}
                />
                <Box>
                    <Grid container m={0}>
                        <SideBarMenuItems selectedTab={SideBarMenuNames.Overview} />
                        <Grid
                            xs={12}
                            className="content-sec"
                            sx={{ "padding-bottom": "100px" }}
                        >
                            <Grid container direction="row" className="">
                                <Grid flex="1" spacing={2} className="form-sec p-0">
                                    <Grid
                                        container
                                        className="title-sec"
                                        alignItems="center"
                                        justifyContent="space-between"
                                    >
                                        <Typography
                                            level="h2"
                                            component="h2"
                                            fontWeight="600"
                                            fontSize="2rem"
                                            className="page-title text-center"
                                        >
                                            <Button onClick={backNavigation} className="back-btn">
                                                <NavigateBeforeIcon fontSize="large" />
                                            </Button>
                                            {pageTitle}
                                        </Typography>

                                        <IconButton onClick={handleCartClick} sx={{ padding: 2 }}>
                                            <ShoppingCartIcon fontSize="large" />
                                        </IconButton>
                                    </Grid>

                                    <Grid
                                        container
                                        xs={12}
                                        className="data-grid-box"
                                    >
                                        <Box sx={{ width: "100%" }}>

                                            {products.length == 0 ? (
                                                <Stack justifyContent="Center" padding={4} marginTop={10} className="text-center">
                                                    <Box
                                                        alignSelf="center"
                                                        component="img"
                                                        sx={{
                                                            height: "160px",
                                                        }}
                                                        alt="Threshold"
                                                        src={noResult}
                                                    />
                                                    <Typography
                                                        component="p"
                                                        fontSize="14px"
                                                        className="mt-2 text-muted"
                                                    >No results found.</Typography>
                                                </Stack>
                                            ) : (
                                                <Box
                                                    className="font-size-14"
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        px: 2,
                                                        py: 1,
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {isSelectedProduct && (
                                                        <Typography sx={{ width: "10%" }}>Select</Typography>
                                                    )}
                                                    <Typography
                                                        fontWeight="600"
                                                        sx={{ width: isSelectedProduct ? "30%" : "33.33%" }}
                                                    >
                                                        Name
                                                    </Typography>
                                                    <Typography
                                                        fontWeight="600"
                                                        sx={{ width: "33.33%" }}>
                                                        On Hand
                                                    </Typography>
                                                    <Typography
                                                        fontWeight="600"
                                                        sx={{ width: "33.33%", textAlign: "right" }}
                                                    >
                                                        Price
                                                    </Typography>
                                                </Box>
                                            )}

                                            {products.map((product, index) => (
                                                <Card
                                                    key={index}
                                                    sx={{
                                                        width: "100%",
                                                        mt: 1,
                                                        px: 2,
                                                        py: 1.5,
                                                        boxShadow: 2,
                                                        borderRadius: 2,
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        {isSelectedProduct && (
                                                            <Checkbox
                                                                checked={product.isChecked || false}
                                                                onChange={(e) =>
                                                                    handleCheckboxChange(index, e.target.checked)
                                                                }
                                                                sx={{ width: "5%" }}
                                                            />
                                                        )}
                                                        <Typography
                                                            fontWeight="600"
                                                            fontSize="1.6rem"
                                                            sx={{
                                                                width: isSelectedProduct ? "30%" : "33.33%",
                                                            }}
                                                        >
                                                            {product.shortDesc}
                                                        </Typography>
                                                        <Typography
                                                            fontSize="1.4rem"
                                                            sx={{ width: "33.33%" }}>
                                                            {product.onHandQuantity}
                                                        </Typography>
                                                        <Typography
                                                            fontSize="1.4rem"
                                                            sx={{ width: "33.33%", textAlign: "right" }}
                                                        >
                                                            {Utils.GetCurrency(
                                                                product.price,
                                                                getCountry(),
                                                                2
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                </Card>
                                            ))}
                                            <br />
                                            {isSelectedProduct && (
                                                <Stack
                                                    direction="row"
                                                    className="fixed-btn"
                                                >
                                                    <Grid container className="container"
                                                        justifyContent="end"
                                                    >
                                                        <Stack direction="row" justifyContent="end" spacing={1} className="font-size-16">
                                                            <Button
                                                                className="btn btn-primary"
                                                                variant="contained"
                                                                color="primary"
                                                                onClick={handleOpenDialog}
                                                                disabled={!isAnyProductSelected}
                                                            >
                                                                Purchase Order
                                                            </Button>
                                                        </Stack>
                                                    </Grid>
                                                </Stack>
                                            )}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Container>
    );
};
export default BelowThreshold;
